import React from "react";

const LearningHero: React.FC = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center px-3 w-full">
        <div className="text-center text-white text-2xl md:text-3xl pt-5 w-full max-w-5xl lg:text-4xl font-light xl:text-[3.4rem] xl:space-y-7">
          <h3 className="">Transform Workplace Learning with</h3>
          <h3>Dream LMS</h3>
        </div>
        <p className="pt-4 xl:pt-8 text-sm xl:text-2xl text-center max-w-2xl font-light text-[#FF7E00]">
          Empower your Learners, streamline training, and achieve measurable
          success with the most intuitive Learning Management System.
        </p>
      </div>
      <div className="flex justify-center items-center pt-[5rem] xl:pt-[5.5rem] -mb-[8rem] md:pt-10 md:-mb-[13rem] xl:-mb-[20rem]">
        <div className="max-w-lg md:max-w-2xl h-[12rem] sm:h-[19rem] rounded-xl lg:rounded-3xl md:w-[34rem] lg:h-[28rem] sm:w-[29rem] lg:max-w-4xl xl:h-[32rem] lg:w-[90rem]">
          <img src="/learning/hero.png" alt="" className="w-full h-full" />
        </div>
      </div>
    </div>
  );
};

export default LearningHero;
